import axios from "axios";
import ConstantList from "../appConfig";
import { getFormData } from "app/common/LocalFunction";

const API_PATH = ConstantList.API_EN_POINT + "/customer-source-group";
const API_PATH_IMPORT = ConstantList.API_EN_POINT + "/excel";

export const pagingCustomerSourceGroup = (searchObject) =>
  axios.post(API_PATH + "/search-by-page", searchObject);

export const getCustomerSourceGroupById = (id) =>
  axios.get(API_PATH + "/get-by-id/" + id);

export const saveCustomerSourceGroup = (obj) =>
  axios.post(API_PATH + "/save-or-update", obj);

export const deleteCustomerSourceGroup = (id) =>
  axios.delete(API_PATH + "/mark-delete/" + id);

export const importCustomerSourceExcel = (file) => {
  let formData = getFormData({ upload: file });
  let url = API_PATH_IMPORT + "/import-customer-source-group";
  return axios({
    url: url,
    headers: {
      "Content-Type": "multipart/form-data",
      Accept: "*/*",
    },
    method: "POST",
    responseType: "blob",
    data: formData,
  });
};

export const syncCustomerSourceGroup = (obj) =>
  axios.post(API_PATH + "/sync-customer-source-group", obj);
